var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("MAHONEKO")]),_c('h2',[_vm._v("魔法喵")]),_c('p',[_vm._v("www.mahoneko.com")])])}]

export { render, staticRenderFns }